module.exports = __webpack_public_path__ + "img/koshheeva.ec58a212.jpg";